import React, { useRef } from "react";
import { Alert, Button, Card, FormControl } from "react-bootstrap";

export default function GenerateYAML(props) {
  const [generatedCode, setGeneratedCode] = React.useState("");
  const textAreaRef = useRef(null);

  function downloadTxtFile() {}

  function copyYAML(e) {
    // e.preventDefault();
    updateYAML();
    // var copyText = generatedCode;
    // e.clipboardData.setData("text/plain", copyText);

    // //console.log("copying " + generatedCode);
    // //navigator.clipboard.writeText(copyText);
    textAreaRef.current.select();
    document.execCommand("copy");
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    e.target.focus();
  }

  function addTab(count) {
    let spaces = "";
    for (let i = 0; i < count; i++) {
      spaces += "    ";
    }
    return spaces;
  }

  function println(content) {
    return content + "\n";
  }

  function updateYAML() {
    let genCode = "";
    let seedersText = "";
    let seedersCount = 0;
    let controllerCount = 0;
    if (props.list.length > 0) {
      genCode = println("models:");
    }
    for (let i = 0; i < props.list.length; i++) {
      genCode += println(addTab(1) + props.list[i].name + ":");
      //add members
      let tMembers = props.list[i].members;
      console.log(tMembers.length);
      for (let j = 0; j < tMembers.length; j++) {
        genCode += println(
          addTab(2) +
            tMembers[j].colName +
            ": " +
            tMembers[j].dataType +
            " " +
            tMembers[j].options
        );
      }

      //add relationships
      let countBelongsTo = props.list[i].belongsTo.length;
      let countBelongsToMany = props.list[i].belongsToMany.length;
      let countHasMany = props.list[i].hasMany.length;
      if (countBelongsTo + countBelongsToMany + countHasMany > 0) {
        genCode += println(addTab(2) + "relationships:");
        genCode +=
          countBelongsTo > 0
            ? println(addTab(3) + "belongsTo: " + props.list[i].belongsTo)
            : "";
        genCode +=
          countBelongsToMany > 0
            ? println(
                addTab(3) + "belongsToMany: " + props.list[i].belongsToMany
              )
            : "";
        genCode +=
          countHasMany > 0
            ? println(addTab(3) + "hasMany: " + props.list[i].hasMany)
            : "";
      }

      if (props.list[i].seeder !== false) {
        if (seedersCount === 0) {
          seedersText = props.list[i].name;
        } else {
          seedersText += ", " + props.list[i].name;
        }
        seedersCount++;
      }

      if (props.list[i].controller !== "None") {
        controllerCount++;
      }
    }

    if (seedersCount > 0) {
      genCode += println("seeders: " + seedersText);
    }

    if (controllerCount > 0) {
      genCode += println("controllers:");
      for (let k = 0; k < props.list.length; k++) {
        if (props.list[k].controller === "None") {
          continue;
        }
        genCode += println(addTab(1) + props.list[k].name + ":");
        if (props.list[k].controller === "Default") {
          genCode += println(addTab(2) + "resource");
        } else {
          genCode += props.list[k].controllerText;
        }
      }
    }
    setGeneratedCode(genCode);
  }

  return (
    <div>
      {props.list.length > 0 && (
        <Card>
          <Card.Header>
            Generated YAML File for{" "}
            <a href="https://blueprint.laravelshift.com/">Laravel Blueprint</a>
          </Card.Header>
          <Card.Body>
            <Card.Text>
              <Alert variant="info">
                <b>Pro tip</b>: You can edit the below content manually, for
                further customization.
              </Alert>
              <FormControl
                as="textarea"
                value={generatedCode}
                ref={textAreaRef}
                onChange={(e) => setGeneratedCode(e.target.value)}
                rows={10}
              />
            </Card.Text>
            {/* <Button variant="primary" onClick={updateYAML}>
        Generate YAML
      </Button>
      &nbsp; */}
            <Button variant="primary" onClick={copyYAML}>
              Generate & Copy YAML
            </Button>
            {/* &nbsp;
      <Button variant="primary" onClick={downloadTxtFile}>
        Download YAML
      </Button> */}
          </Card.Body>
        </Card>
      )}
      {props.list.length == 0 && (
        <Alert variant="info">
          <b>LARAFAST:</b> Not much to generate (yet)!
        </Alert>
      )}
    </div>
  );
}
